export const avatarSelector = (state) =>
  state.app.talentProfile.profile.firstSectionProfile?.imageUrl;
export const profileSelector = (state) => state.app.talentProfile.profile;
